import type { TMetadataFile } from '@fingerprinting/types/schemas/file.schema'

export const CONSTANT_BYTE = 1024 as const
export const LIST_SIZE = ['Bytes', 'KB', 'MB', 'GB'] as const

export const MAX_FILE_SIZE = 10 * CONSTANT_BYTE * CONSTANT_BYTE // 10MB
export const ACCEPTED_FILE_TYPES = [
  'image/jpg',
  'image/png',
  'image/jpeg',
  'application/pdf',
  'application/msword',
  'image/webp',
  'image/heic',
  'image/heif',
  'image/heif-sequence',
  'image/heic-sequence',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
] as const

export function formatFileSize(bytes: number): string {
  if (bytes === 0) {
    return '0 Bytes'
  }

  const i = Math.floor(Math.log(bytes) / Math.log(CONSTANT_BYTE))
  const unit = LIST_SIZE[i]
  const value = Number((bytes / Math.pow(CONSTANT_BYTE, i)).toFixed(2))
  return `${value} ${unit}`
}

export function processFileToMetadataFile(file: File) {
  const url = URL.createObjectURL(file)
  const { name, size, type } = file
  return {
    size,
    filePath: url,
    fileName: name,
    previewUrl: url,
    downloadUrl: url,
    contentType: type || undefined,
  } satisfies TMetadataFile
}

export async function restoreFileFromMetadataFile(metadataFile: TMetadataFile): Promise<File> {
  const { fileName, filePath } = metadataFile
  const res = await fetch(filePath)
  const blob = await res.blob()

  const { type } = blob

  return new File([blob], fileName, {
    type,
    lastModified: Date.now(),
  })
}

export function getExtensionFromPathname(pathname: string) {
  if (!pathname.includes('.')) {
    return pathname.toLowerCase()
  }

  return pathname.split('.').pop()!.toLowerCase()
}

export function removeFileSuffix(filename: string): string {
  if (!filename) return filename

  const suffixPattern = /_Doc\d+_\d+(?=\.|$)/
  return filename.replace(suffixPattern, '')
}

export function downloadFile(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  a.remove()
  URL.revokeObjectURL(url)
}
